module.exports = __webpack_public_path__ + "img/wish.cfcaa25.svg?v=1763034624171";